import React from 'react';

export const EnableSchemaContext = React.createContext<boolean>(true);

interface EnableSchemaProviderProps {
  children: React.ReactNode;
  enableSchema: boolean;
}

export const EnableSchemaContextProvider: React.FC<EnableSchemaProviderProps> = ({
  children,
  enableSchema,
}) => {
  return (
    <EnableSchemaContext.Provider value={enableSchema}>{children}</EnableSchemaContext.Provider>
  );
};

export const useEnableSchema = (): boolean => {
  return React.useContext(EnableSchemaContext);
};
